"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const useMergeRefs_1 = __importDefault(require("../../../hooks/useMergeRefs"));
const ExpandCollapse_1 = __importDefault(require("../../ExpandCollapse/ExpandCollapse"));
const AccordionItem = (0, react_1.forwardRef)(({ children = null, title = "", className = "", iconSize = 24, id, open, onClick, onClickAccordionCallback }, ref) => {
    // Change onClick param name to onClickCallback in 1.0.0
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const onClickCallback = (0, react_1.useCallback)(() => {
        onClickAccordionCallback && onClickAccordionCallback();
        onClick && onClick();
    }, [onClickAccordionCallback, onClick]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: mergedRef, className: (0, classnames_1.default)("accordion-item", className), id: id }, { children: (0, jsx_runtime_1.jsx)(ExpandCollapse_1.default, Object.assign({ iconSize: iconSize, id: `expand-collapse--${id}`, onClick: onClickCallback, open: open, title: title }, { children: children })) })));
});
exports.default = AccordionItem;
